<template>
    <div>
        <div class="m-share">
            <div class="top">
                <div class="left">
                    <span>{{shareItem.name}}</span>
                    <span>{{shareItem.widthHeight}}</span>
                </div>
                <div class="right">
                    <el-button @click="copyEdit" type="primary" round>复制并编辑</el-button>
                    <el-button @click="goHome" round>返回首页</el-button>
                </div>
            </div>
            <div>
                <img :src="shareItem.url" @click="copyEdit">
            </div>
        </div>
    </div>
</template>
<script>
    import worksService from '../../request/service/works-service';
    import {template_type_multiple} from '@/const.js';

    export default {
        components: {},
        data() {
            return {
                id: this.$route.params.id,
                type: null,
                shareItem: {},
            }
        },
        created() {
            worksService.getWorksById(this.id).then((data) => {
                this.shareItem = data;
            });
        },
        computed: {
            project() {
                return this.$store.state.app.projectId;
            }
        },
        methods: {
            goHome() {
                window.location.href = window.location.origin;
            },
            copyEdit() {
                let self = this;
                worksService.copyWorks({workId: this.shareItem.id, projectId: this.project}).then((data) => {
                    this.$message({
                        type: 'success',
                        message: '复制成功，请开始编辑'
                    });
                    let {type, free} = data;
                    let url = '/';
                    if(free){
                        window.location.href = `/#/workFree/${data.id}/editor?type=my`;
                    }else{
                        let url = type === template_type_multiple ? `/#/workGroup/${data.id}/editor?type=my`: `/#/works/${data.id}/editor?type=my`;
                        window.location.href = url;
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    @import './index.scss'
</style>

